// extracted by mini-css-extract-plugin
module.exports = {"homeContainer":"Home_homeContainer__33wKH","bor":"Home_bor__2P0yZ"};